import { getUserJwt } from '../../context/AuthHelper';
import { METHOD_GET, METHOD_POST } from '../constants/apis';
import { STRAPI_URL } from '../constants/url';
import { getQueryString } from './Population';

/**
 * Authenticates the user
 * @param {string} userName | username entered by user
 * @param {string} password | password entered by user
 * @returns | returns a responseBody from the API
 */
export default async function AuthUser(userName: string, password: string) {
	let response = await fetch(`${STRAPI_URL}/api/auth/local`, {
		method: METHOD_POST,
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({ identifier: userName, password: password }),
	});

	if (response.ok) {
		let responseData = await response.json();
		return responseData;
	}

	const err = await response.text();
	throw new Error(err);
}

export async function GetUserMe(jwt = '') {
	let poplevel = [{ Person: 'id', 'Person.Organisation': 'id' }];
	let filter: any[] = [];
	let sort: any[] = [];
	let pagination: object = {};
	let fields: any = [];
	let response = await fetch(`${STRAPI_URL}/api/users/me${getQueryString(poplevel, filter, sort, pagination, fields)}`, {
		method: METHOD_GET,
		headers: {
			Authorization: `Bearer ${jwt ? jwt : getUserJwt()}`,
		},
	});

	if (!response.ok) {
		throw new Error(await response.text());
	}
	const responseData = await response.json();
	return responseData;
}

export async function ChangeUserPassword(data: Record<string, any>) {
	// let data = {
	// 	currentPassword: oldPassword,
	// 	password: newPassword,
	// 	passwordConfirmation: newPasswordRepeat,
	// };

	let response = await fetch(`${STRAPI_URL}/api/auth/change-password`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${getUserJwt()}`,
		},
		body: JSON.stringify(data),
	});

	if (response.ok) {
		let responseData = await response.json();
		return responseData;
	}

	const err = await response.text();
	throw new Error(err);
}
